<template>
  <div>
    <h1 class="text-pagename text-xs-center">Refill credit history</h1>
    <!-- {{ rider_wallet }} -->
    <v-data-table
      :headers="headers"
      :loading="loading_message"
      :items="refill_credit_list"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ refill_credit_list.indexOf(props.item) + 1 }}
        </td>
        <td class="text-xs-center">{{ props.item.wt_date }}</td>
        <td class="text-xs-center">{{ props.item.wt_time }}</td>
        <td v-if="isLoadingRider">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </td>
        <td v-else style="max-width: 200px; overflow: auto">
          {{ showRiderName(props.item) }}
        </td>
        <td class="text-xs-right">
          {{
            parseFloat(props.item.wt_credit)
              .toFixed(2)
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }}
        </td>
        <td class="text-xs-center">{{ props.item.wt_order_code }}</td>
        <td>{{ props.item.wt_remark }}</td>
        <td>{{ props.item.wt_note }}</td>
      </template>

      <template slot="no-data">
        <div v-if="loading_message == false" class="text-xs-center">
          No data available
        </div>
        <div v-else class="text-xs-center">
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular
          >Loading data ...
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({
    loading_message: false,
    requestCashDialog: false,
    dialog: false,
    item_detais: {},
    pagination: {
      page: 1,
      rowsPerPage: 10,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "num",
      },
      {
        text: "Date",
        align: "center",
        value: "date",
        sortable: false,
      },
      {
        text: "Time",
        align: "center",
        value: "time",
        sortable: false,
      },
      {
        text: "Rider Name",
        align: "center",
        value: "rider_name",
        sortable: false,
      },
      {
        text: "Credit",
        align: "center",
        value: "credit",
        sortable: false,
      },
      {
        text: "Order code",
        align: "center",
        value: "rider_name",
        sortable: false,
      },
      {
        text: "Remark zone",
        align: "center",
        value: "rider_name",
        sortable: false,
      },
      {
        text: "Note",
        align: "center",
        value: "credit",
        sortable: false,
      },
    ],
    data: [
      {
        num: 1,
        date: "15-12-2019",
        time: "12:30",
        rider_name: "first last",
        credit: 123,
      },
    ],
    riderList: [],
    isLoadingRider: false,
  }),
  computed: {
    ...mapState({
      refill_credit_list: (state) => state.fetchCashRider.refill_credit_list,
    }),
  },
  methods: {
    ...mapActions({
      fetchRiderBOF: "fetchRiderListBack/fetchRiderBOF",
    }),
    showRiderName(item) {
      let findItem = this.riderList.find(
        (val) => val.users.id == item.wt_rider
      );
      if (findItem) {
        return findItem.users.users_name;
      }
      return "";
    },
    async getRiderList() {
      this.riderList = await this.fetchRiderBOF();
      this.isLoadingRider = false;
      return;
    },
  },
  async created() {
    this.loading_message = true;
    this.isLoadingRider = true;
    await this.$store.dispatch("fetchCashRider/getRefillCredit");
    await this.getRiderList();
    this.loading_message = false;
  },
};
</script>

<style scoped>
.style-status {
  border-radius: 20px;
}
</style>
